import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RegistrosService } from '../registros.service';
import { ResponseInterface } from 'app/modules/models/response.model';
import { BitacoraRegistroInterface } from './bitacora-registro.model';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-bitacora',
    templateUrl: 'bitacora.component.html',
    imports:[CommonModule]
})

export class BitacoraComponent implements OnInit, OnChanges {
    @Input() entidadUuid:string = ''
    bitacora: BitacoraRegistroInterface[] = []

    constructor(private _registrosService:RegistrosService) { }

    ngOnInit() {
        this.getBitacora();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['entidadUuid'] && changes['entidadUuid'].currentValue) {
            this.getBitacora();
        }
    }

    getBitacora(){
        if (!this.entidadUuid) {
            return;
        }
        this._registrosService.getBitacoraRegistro(this.entidadUuid)
            .then((response: any) => {
                this.bitacora = response.data.bitacoras as BitacoraRegistroInterface[];
            })
            .catch(() => this.bitacora = [])
    }
}
